import { DefaultValueConfig } from '@headless-workspace/config';
import { UrlHelpers } from '@headless-workspace/utils';
import { CountrySpecificitiesRule } from './CountrySpecificitiesRule';
import { DynamicHrefValue } from './DynamicHrefValue';
import { DynamicIconValue } from './DynamicIconValue';
import { DynamicLabelDTO } from './DynamicLabelDTO';

export type DynamicLabelValue = {
    text: string;
    href: string;
    rule: CountrySpecificitiesRule;
    iconName?: string;
    displayClassName?: string;
};

export const mapDynamicLabel = (dto: DynamicLabelDTO | undefined): DynamicLabelValue | undefined => {
    if (!dto) {
        return undefined;
    }

    return {
        text: dto.text,
        href: UrlHelpers.createPathFromEnv(dto.url) ?? DefaultValueConfig.href,
        rule: {
            key: dto.rule.key,
            value: dto.rule.value,
        },
        displayClassName: dto.displayRules,
        iconName: dto.iconName,
    };
};

export const isDynamicLabelValue = (
    value: DynamicIconValue | DynamicHrefValue | DynamicLabelValue,
): value is DynamicLabelValue => {
    return 'text' in value && !!value.text;
};
